import { Box, IconButton, Typography } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

export const PermitionItem = ({
	title,
	type,
	onClick,
}: {
	title: string;
	type: 'add' | 'remove';
	onClick: () => void;
}) => {
	return (
		<Box
			sx={{
				backgroundColor: title === 'admin' ? 'secondary.main' : 'primary.main',
				borderRadius: '12px',
				p: 1,
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				cursor: 'pointer',
			}}
			onClick={onClick}
		>
			<Typography
				variant="body2"
				color="primary.contrastText"
				align="center"
				sx={{ fontWeight: 'bold' }}
			>
				{title}
			</Typography>
			<IconButton sx={{ p: 0 }}>
				{type === 'add' ? (
					<Add sx={{ color: 'primary.contrastText', p: 0 }} />
				) : (
					<Delete sx={{ color: 'primary.contrastText', p: 0 }} />
				)}
			</IconButton>
		</Box>
	);
};
